<template>
  <v-form ref="form" v-model="valid" lazy-validation class="pt-12 feadback-form">
    <v-card tile flat class="white">
      <v-card-subtitle color="primary">Если у вас есть какие-либо вопросы — задавайте их нам!</v-card-subtitle>
    </v-card>
    <v-text-field
      class="strongtextfield"
      outlined
      v-model="name"
      :counter="45"
      :rules="nameRules"
      label="ФИО"
      required
    ></v-text-field>

    <v-text-field
      class="strongtextfield"
      outlined
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      required
    ></v-text-field>

    <v-textarea
      outlined
      class="strongtextfield"
      v-model="text"
      :counter="300"
      :rules="textRules"
      label="Текст сообщения"
    ></v-textarea>

    <v-checkbox
      v-model="agreement"
      :rules="[v => !!v || 'Вы должны дать свое согласие!']"
      label="Я даю своё согласие на обработку моих персональных данных"
      required
    ></v-checkbox>

    <v-btn tile :disabled="!valid" :loading="loading" color="primary" class="mr-4 pl-10 pr-10" @click="validate"
      >Отправить</v-btn
    >
    <v-alert v-if="notice" dense text type="success" class="mt-12">
      Ваше сообщение отправлено. В течение 1 -го дня мы обязательно свяжемся с Вами.
    </v-alert>
    <v-alert v-if="alert" dense text type="error" class="mt-12">
      Что-то пошло не так. Сообщите, пожалуйста об ошибке нам по телефону или email.
    </v-alert>
  </v-form>
</template>

<script>
export default {
  name: "feedbackform",

  data: () => ({
    loading: false,
    alert: false,
    notice: false,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "ФИО необходимо указать обязательно",
      v => (v && v.length <= 45) || "ФИО должно быть меньше 45 символов"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail обязателен",
      v => /.+@.+\..+/.test(v) || "E-mail должен быть похожим на почтовый адрес"
    ],
    text: "",
    textRules: [
      v => !!v || "Текст сообщения обязателен",
      v => (v && v.length <= 300 && v.length > 10) || "Текст должен быть меньше 300 и больше 10 символов"
    ],
    agreement: false
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid) {
        var bodyFormData = new FormData();
        bodyFormData.append("name", this.name);
        bodyFormData.append("email", this.email);
        bodyFormData.append("text", this.text);
        bodyFormData.append("agreement", this.agreement);

        let self = this;
        this.loading = true;
        this.axios
          .post("/sendmail.php", bodyFormData, { headers: { "Content-Type": "multipart/form-data" } })
          .then(response => {
            self.notice = true;
            self.loading = false;
            setTimeout(() => (self.notice = false), 3000);
            console.log(response.data);
          })
          .catch(function(error) {
            self.alert = true;
            self.loading = false;
            setTimeout(() => (self.alert = false), 3000);
            console.error(error);
          });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped>
.strongtextfield {
  border-radius: 0;
}
form.feadback-form {
  max-width: 1024px;
}
</style>
